import myaxios from '@/myaxios.js'
const state = {
    anaesthesiaMethod: []
}

const mutations = {
    SET_ANAESTHESIA_METHOD: (state, anaesthesiaMethod) => {
        state.anaesthesiaMethod = anaesthesiaMethod
    }
}

const actions = {
    ADD_ANAESTHESIA_METHOD: function({ commit, getters }) {
        myaxios.get(`/api/AcisSystem/AnaesthesiaMethod/Get`).then((data) => {
            // disabled: true
            // commit('SET_ANAESTHESIA_METHOD', _.filter(data,{is_deleted:false}))
            commit(`SET_ANAESTHESIA_METHOD`, data)
        }).catch(error => {
            console.log(error)
        })
    }
}

const getters = {
    anaesthesia_method: (state, getters) => {
        return _.map(state.anaesthesiaMethod, d => {
            return { label: `${d.name}`, value: d.id, jianpin: d.abbr, disabled: d.is_deleted, enum_dic_type: d.enum_dic_type }
        })
    }
}
export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/surgery.js